import React from 'react';
import { useLocale, useRecordContext } from 'react-admin';
import { StatusCell } from '../components/StatusCell';
import { siedCellVariant } from './siedCell';
import { langOf, SIED_LABELS, siedAgo, siedDisplay } from './siedStatus';

type SiedFields = {
  region?: string | null;
  sied_status?: string | null;
  sied_status_raw?: string | null;
  sied_status_checked_at?: string | null;
};

/**
 * The SIED step as one 24px square, same component as REG / DEC. The hover
 * text carries what the long pill said: full label, SIED's own FR text and
 * when it was checked. Read-only on the list; signing lives in the sidebar.
 */
export const SiedStatusCell: React.FC<{ record?: SiedFields }> = ({ record: recordProp }) => {
  const ctx = useRecordContext<SiedFields>();
  const record = recordProp ?? ctx;
  const lang = langOf(useLocale());
  const d = siedDisplay(record?.sied_status);

  const title = d
    ? [
        `SIED: ${d.long[lang]}`,
        record?.sied_status_raw ? `SIED : ${record.sied_status_raw}` : '',
        record?.sied_status_checked_at
          ? `${SIED_LABELS.checked[lang]} ${siedAgo(record.sied_status_checked_at, lang)}`
          : '',
      ]
        .filter(Boolean)
        .join('\n')
    : lang === 'fr'
      ? 'SIED : aucun formulaire lié'
      : 'SIED: no form linked';

  return (
    <span data-sied-status={record?.sied_status ?? ''} className="inline-flex">
      <StatusCell variant={siedCellVariant(record?.sied_status)} title={title} />
    </span>
  );
};

export default SiedStatusCell;
